import Parse, { User } from 'parse'
import moment from 'moment-timezone'
import { param } from 'jquery';

moment.tz.setDefault('America/Mexico_City');

class SlideShow extends Parse.Object {
  constructor() {
    super('Slideshow');
  }
  
  get createdAt () {
    return this.get('createdAt')
  }
  
  get title () {
    return this.get('title')
  }

  get description () {
    return this.get('description')
  }

  get cover () {
    return this.get('cover').url()
  }

  /* -- Load */

  static load (limit = 2000, skip = 0) {

    const query = new Parse.Query(this)
    
    query.limit(limit)
    query.skip(skip)
    query.ascending('createdAt')

    return query.find()
  }

  static saveSlide(params){

    const slide = new SlideShow()
    const pc = SlideShow.createWithoutData(params.id)

    pc.set("title", params.title)
    pc.set("description", params.description)

    if( typeof(params.file) != "string"){

      const file = params.file;
      const name = "demo.png";

      const iconImageFile = new Parse.File(name, file);
      pc.set('cover', iconImageFile) 

    } else {
      slide.set('cover', params.file) 
    }

    return pc.save()

    /*
  
    const slide = new SlideShow()
    
    const file = params.file;
    const name = "demo.png";

    const iconImageFile = new Parse.File(name, file);
    
    slide.set('title', params.title)
    slide.set('description', params.description)
    slide.set('cover', iconImageFile) 

    return slide.save()*/
  }



  
  dump () {
    console.log(this)
  }
}

export default SlideShow
